import { apiFetch } from '@nrdy-marketing-engine/api-fetch';

interface PaymentToken {
  token: string;
}

const opts = { host: process.env.NEXT_PUBLIC_VT_WWW_ENDPOINT, method: 'POST' };

const getPaymentToken = async (): Promise<string> =>
  process.env.NEXT_PUBLIC_BRAINTREE_TOKEN ||
  apiFetch<PaymentToken>('/api/v3/payment/token', opts).then(({ token }) => token);

export default getPaymentToken;
